import { Column } from 'src/shared/components/Semantic/all'
import { PageContainer } from 'src/shared/components/PageContainer'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { Footer } from 'src/shared/components/Footer'

import {
  FeatureCard,
  FeatureDescription,
  FeatureTitle,
  getFeatures,
} from './BentoGrid'
import { MacroProblemSection } from './components/MacroproblemSection'
import { ESGSection } from './components/ESGSection'

export const AboutPage = () => {
  const { t } = useLocalization()

  return (
    <Column className="relative">
      <PageContainer>
        <h4 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl lg:leading-tight max-w-5xl mx-auto text-center tracking-tight text-black dark:text-white">
          {t('A merch partner since 2015.', 'En merchpartner sedan 2015.')}
        </h4>

        <Column className="gap-2 my-4">
          <p className="sm:text-sm md:text-base max-w-2xl mx-auto text-neutral-500 text-center font-normal dark:text-neutral-300 px-2">
            {t(
              'We’ve been serving customers with branded merchandise since 2015. A real Klayder team on every order, from idea to delivery, now in one place.',
              'Vi har hjälpt kunder med profilprodukter sedan 2015. Ett riktigt Klayder-team på varje order, från idé till leverans, nu på ett ställe.'
            )}
          </p>
        </Column>

        <div className="relative mb-6">
          <div className="grid grid-cols-1 lg:grid-cols-6 mt-8 sm:mt-12 xl:border rounded-md dark:border-neutral-800 overflow-hidden">
            {getFeatures(t).map((feature) => (
              <FeatureCard key={feature.title} className={feature.className}>
                <FeatureTitle>{feature.title}</FeatureTitle>
                <FeatureDescription>{feature.description}</FeatureDescription>
                <div className=" h-full w-full">{feature.skeleton}</div>
              </FeatureCard>
            ))}
          </div>
        </div>
      </PageContainer>

      <MacroProblemSection />
      <ESGSection />

      <Footer />
    </Column>
  )
}
